import React from 'react';
import styles from './ProfileOptionsList.module.scss';
import { DropDownItem } from '../DropdownMenu/DropDownItem';
import { useTranslation } from 'react-i18next';

const ProfileOptionsList = ({ options, onSelect = () => {} }) => {
  const { t } = useTranslation();

  return (
    <>
      {options ? (
        <ul className={styles.optionsContainer}>
          {Object.entries(options).map(optionItem => (
            <li key={optionItem[0]} className={styles.menuSection}>
              <ul className={styles.sectionList}>
                {optionItem[1].map(item =>
                  item ? (
                    <DropDownItem
                      onClick={() => (item.path ? onSelect(item.path) : item.action && item.action())}
                      languageFlag={item.flagImage}
                      key={item.name}
                      id={item.id}
                    >
                      {t(item.name)}
                    </DropDownItem>
                  ) : null
                )}
              </ul>
            </li>
          ))}
        </ul>
      ) : null}
    </>
  );
};

export default ProfileOptionsList;
